import { render } from "./OrdersSum.vue?vue&type=template&id=3067e4c4"
import script from "./OrdersSum.vue?vue&type=script&lang=js"
export * from "./OrdersSum.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__